let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gvVQr")).then(() => parcelRequire('fYqHn'));